import React from 'react';
import { Link } from 'react-router-dom';

// Lean landing page for the admin console. The clinical app's widget/chart
// dashboard is intentionally replaced with a simple hub.
const Dashboard = () => (
  <>
    <div className="page-titles">
      <ol className="breadcrumb">
        <li className="breadcrumb-item active"><span>Home</span></li>
      </ol>
    </div>
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <h4 className="mb-2">Praxxis Admin User Layer (PAUL)</h4>
            <p className="text-muted mb-3">Manage back-office reference and catalog data.</p>
            <Link to="/admin/distributors" className="btn btn-primary btn-sm">Go to Distributors</Link>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default Dashboard;
